module.exports = __webpack_public_path__ + "static/media/default.cef72080.svg";